(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('supplierRemoveAction', {
      controller: Controller,
      templateUrl: 'actions/supplier/remove/remove-supplier.action.html',
      bindings: {
        supplierId: '<',
        then: '&',
        catch: '&'
      }
    });
}());
